module.exports = __webpack_public_path__ + "promo/app-store-badges/google-play-store-ja-68308f2d8941723ed1f40da8a6917272.svg";


//////////////////
// WEBPACK FOOTER
// ./images/promo/app-store-badges/google-play-store-ja.svg
// module id = xAZu
// module chunks = 19